import { defineMessages, useIntl } from 'react-intl';
import { PictogramName } from '@cbhq/cds-common';
import { Box, HStack, VStack } from '@cbhq/cds-web/layout';
import { Pressable } from '@cbhq/cds-web/system';
import { TextHeadline, TextLabel2 } from '@cbhq/cds-web/typography';

import { RemoteImage } from '../RemoteImage';

const messages = defineMessages({
  cardLabel: {
    id: 'DangerousNudgeCard.cardLabel',
    defaultMessage: '{title} {description}',
    description: 'Accessibility label for the nudge card link',
  },
});

type Props = {
  testID?: string;
  title: string;
  description: string;
  image: PictogramName;
  href: string;
};

/**
 * TODO: @bruno-mota
 * This needs to be replaced with the CDS's NudgeCard component.
 */
export function DangerousNudgeCard({ title, description, image, href, testID }: Props) {
  const { formatMessage } = useIntl();

  return (
    <Box testID={testID}>
      <Pressable
        testID="DangerousNudgeCard-link"
        href={href}
        background="transparent"
        accessibilityLabel={formatMessage(messages.cardLabel, { title, description })}
        target="_blank"
        borderRadius={500}
        as="a"
      >
        <HStack
          padding={2}
          gap={3}
          background="bgPrimaryWash"
          borderRadius={500}
          alignItems="center"
        >
          <VStack padding={1} gap={0.5}>
            <TextHeadline as="p" display="block">
              {title}
            </TextHeadline>
            <TextLabel2 as="p" display="block">
              {description}
            </TextLabel2>
          </VStack>
          <RemoteImage source={image} />
        </HStack>
      </Pressable>
    </Box>
  );
}
